import * as R from 'ramda';

export default function ApproveImpactAnalysisDialogController(
  $filter,
  $rootScope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  loaderService,
  bcpDataService
) {
  const vm = this;

  vm.activeProcess = $filter('filter')(vm.processes, { canApproveImpactAnalysis: true, }, true)[0];
  vm.activeProcess.recoveryTimeObjective = vm.activeProcess.recoveryTimeObjective || 0;
  vm.activeProcess.maximumAcceptableDowntime = vm.activeProcess.maximumAcceptableDowntime || 0;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleNavToProcess = _handleNavToProcess;
  vm.handleApproveImpactAnalysisFormSubmit = _handleApproveImpactAnalysisFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _setActiveProcessFunctionNames();
    _triggerGraphReRender().then(dfdActivate.resolve);

    dfdActivate.promise.then(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.approveImpactAnalysisDialog);
  }

  function _handleNavToProcess(processId) {
    const newActiveProcess = $filter('filter')(vm.processes, { processId, }, true)[0];
    if (vm.activeProcess !== newActiveProcess) {
      vm.contentPaneIsFaded = true;
      $timeout(
        () => {
          vm.activeProcess = newActiveProcess;
          // _resetContentPaneScroll();
          _setActiveProcessFunctionNames();
          _triggerGraphReRender();
          vm.contentPaneIsFaded = false;
        },
        120
      );
    }
  }

  /** *********************************
   * Private Functions
   */

  function _setActiveProcessFunctionNames() {
    let _activeProcessFunctionNameList = '';
    if ((vm.activeProcess.assessmentFunctions !== null) && (vm.activeProcess.assessmentFunctions.length > 0)) {
      const _sortedFunctions = R.sortBy(R.prop('name'), vm.activeProcess.assessmentFunctions);
      angular.forEach(_sortedFunctions, (assessmentFunction) => {
        if (_activeProcessFunctionNameList === '') {
          _activeProcessFunctionNameList = assessmentFunction.name;
        } else {
          _activeProcessFunctionNameList = `${_activeProcessFunctionNameList}, ${assessmentFunction.name}`;
        }
      });
    }

    vm.activeProcess.activeProcessFunctionNameList = _activeProcessFunctionNameList;
  }

  function _triggerGraphReRender() {
    const dfdReRender = $q.defer();
    $timeout(() => {
      $rootScope.$broadcast('reRenderImpactAnalysisGraph', { processId: vm.activeProcess.processId, });
      dfdReRender.resolve();
    }, 20);
    return dfdReRender.promise;
  }

  // function _resetContentPaneScroll() {
  //   angular.element(
  //       '.bcp--approve-impact-analysis-content-pane'
  //   )[0].scrollTop = 0;
  // }

  function _handleApproveImpactAnalysisFormSubmit() {
    loaderService.showViewLoader = true;
    const affectedProcesses = [];
    angular.forEach(vm.processes, (currentProcess) => {
      if (currentProcess.impactAnalysis.approved !== null) {
        const process = {
          assessmentProcessId: currentProcess.assessmentProcessId,
          isApproved: currentProcess.impactAnalysis.approved,
          denialNotes: currentProcess.impactAnalysis.denialNotes,
        };
        affectedProcesses.push(process);
      }
    });

    bcpDataService.approveOrDenyProcesses(affectedProcesses).then(
      () => {
        alerts.success('The Business Impact Analysis Process(es) have been approved/denied successfully.');
        ssDialogService.hide(ssDialogService.dialogs.bcp.approveImpactAnalysisDialog);
        $rootScope.$broadcast('refreshBCPAssessments');
        loaderService.showViewLoader = false;
      },
      () => {
        alerts.error('The approval/denial of the Busines Impact Analysis Process(es) has failed.');
        loaderService.showViewLoader = false;
      }
    );
  }
}

ApproveImpactAnalysisDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'loaderService',
  'bcpDataService'
];
